import { useEffect, useState } from "react";

const NAV = [
  { href: "#intro", label: "漫画是什么" },
  { href: "#system", label: "系统介绍" },
  { href: "#world", label: "设定与世界观" },
  { href: "#plot", label: "剧情梗概" },
  { href: "#characters", label: "角色介绍" },
  { href: "#faq", label: "常见问题" },
];

const TOPICS = ["恋爱辅助器漫画设定", "恋爱辅助器系统介绍", "恋爱辅助器剧情梗概", "恋爱辅助器故事背景", "恋爱辅助器世界观"];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <footer className="bg-background-100 pt-14">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid gap-10 md:grid-cols-4">
            <div className="md:col-span-2">
              <a href="#top" className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-heart-3-fill text-lg"></i>
                </span>
                <span className="font-heading text-lg text-foreground-900">
                  恋爱辅助器<span className="text-primary-600">漫画</span>全解析
                </span>
              </a>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
                专注《恋爱辅助器》这部浪漫治愈系漫画的设定、系统与剧情解析，
                帮每一位感兴趣的读者快速读懂它的世界观与独特魅力。本站仅做内容科普，不提供任何盗版资源。
              </p>
              <div className="mt-5 flex gap-3">
                <a href="#track" aria-label="前往追更页面" className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-primary-100 hover:text-primary-700">
                  <i className="ri-smartphone-line"></i>
                </a>
                <a href="mailto:contact@love-comic.readdy.site" aria-label="发送邮件联系我们" className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-primary-100 hover:text-primary-700">
                  <i className="ri-mail-line"></i>
                </a>
                <a href="#faq" aria-label="查看常见问题" className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-primary-100 hover:text-primary-700">
                  <i className="ri-question-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-heading text-base text-foreground-900">栏目导航</h3>
              <ul className="mt-4 space-y-2.5">
                {NAV.map((n) => (
                  <li key={n.href}>
                    <a href={n.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base text-foreground-900">热门话题</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {TOPICS.map((t) => (
                  <a
                    key={t}
                    href="#intro"
                    className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-600 ring-1 ring-background-200 transition-colors hover:bg-accent-100 hover:text-accent-700"
                  >
                    #{t}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 py-6 sm:flex-row">
            <p className="text-xs text-foreground-500">
              © 2026 恋爱辅助器漫画全解析 · 内容科普站点
            </p>
            <p className="text-xs text-foreground-500">以真诚的视角，聊聊一部真诚的漫画。</p>
          </div>
        </div>
      </footer>

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </>
  );
}